<script lang="ts">
    import {onMount} from "svelte";
    import {UrlUtil} from "../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../lib/Common/Http/HttpRequestUtil";
    import LoadingContentView from "../../../component/common/Loading/LoadingContentView.svelte";
    import ArraySlotView from "../../../component/common/Value/ArraySlotView.svelte";
    import TipsMessageAreaView from "../../../component/common/Message/TipsMessageAreaView.svelte";
    import LabelValueView from "../../../component/common/Value/LabelValueView.svelte";
    import {MessageStore} from "../../../store/MessageStore";
    import DiffRowView from "./DiffRowView.svelte";
    import ButtonView from "../../../component/common/Button/ButtonView.svelte";

    export let params;

    $: isClean = (() => {
        if (gitStatusArray == null) {
            return false;
        }
        const gitStatusArrayLength = gitStatusArray.length;
        if (gitStatusArrayLength === 0) {
            return false;
        }
        const lastGitStatus = gitStatusArray[gitStatusArrayLength - 1];
        if (lastGitStatus === 'nothing to commit, working tree clean') {
            // 変更がない場合、最後の行が nothing to commit, working tree clean になっている
            return true;
        } else {
            return false;
        }
    })();

    $: isCommittable = (() => {
        if (isFinish) {
            // 反映済の場合はコミット不可
            return false;
        }
        if (isClean) {
            // 変更なしであれば、コミット不可
            return false;
        }

        return true;
    })();


    let isLoading = false;

    let spaceName = null;
    let spaceDescription = null;
    let spaceGitWebUrl = null;
    let spaceGitSshUrl = null;
    let mailAddress = null;
    let diffGitRevision = null;
    let diffCreatedAt = null;

    let gitStatusArray = null;
    let gitDiffArray = null;

    let commitMessage = '';

    let isFinish = false;

    onMount(() => {
        loadData();

    });

    function loadData() {
        gitStatusArray = null;
        gitDiffArray = null;

        const paramMap = {};
        const diffUrlToken = params.diff_url_token;
        paramMap['diff_url_token'] = diffUrlToken;


        const url = UrlUtil.createApiUrl("temp_csv/diff", paramMap);

        isLoading = true;
        HttpRequestUtil.getRequest(url, (response) => {
            isLoading = false;
            console.log(response);
            const body = response['body'];
            // episodes = body['episodes'];

            gitStatusArray = body['git_status'];
            gitDiffArray = body['git_diff'];

            spaceName = body['space_name'];
            spaceDescription = body['space_description'];
            spaceGitWebUrl = body['git_web_url'];
            spaceGitSshUrl = body['git_ssh_url'];

            mailAddress = body['mail_address'];
            diffGitRevision = body['diff_git_revision'];
            diffCreatedAt = body['diff_created_at'];

            // gitStatusArray の 最後の行が nothing to commit, working tree clean の場合、変更対象なし


        });
    }

    function commitPush() {
        const paramMap = {};
        const diffUrlToken = params.diff_url_token;
        paramMap['diff_url_token'] = diffUrlToken;
        paramMap['commit_message'] = commitMessage;

        const url = UrlUtil.createApiUrl("temp_csv/commit");

        isLoading = true;
        HttpRequestUtil.postRequest(url, paramMap, (response) => {
            isLoading = false;
            console.log(response);
            const body = response['body'];
            // episodes = body['episodes'];

            // 画面を変更
            isFinish = true;
        });
    }

    function onClickCommitPush() {
        if (commitMessage === '') {
            MessageStore.showConfirmInformation("コミットメッセージが入力されていません");
            return;
        }

        MessageStore.showConfirmDangerYesNo("コミット & プッシュを実行してもよろしいですか？\nこれにより、エンジニアに変更が伝わります", () => {
            commitPush();
        });

    }

    function onHashChange(event) {
        loadData();
    }

</script>

<svelte:window on:hashchange={onHashChange}/>

<div class="diff-temporary-csv-page standard-page">
    {#if isFinish}
        <h1>この {spaceName} のデータは反映済です</h1>
    {:else if isClean}
        <h1>この {spaceName} のデータは変更されていません</h1>
    {:else}
        {#if spaceName != null}
            <h1>
                {spaceName} のデータの更新前確認です
            </h1>

        {/if}
    {/if}

    {#if isFinish}
        <TipsMessageAreaView>
            diff url token は無効になっているため、リロードするとこの画面を表示されません
        </TipsMessageAreaView>
    {/if}

    <div>
        <LabelValueView label="diff url token" value={params.diff_url_token}
                        hoverTipsMessage="基本的にこれは他社に共有しないでください。他の方が反映できてしまいます"
        />


    </div>
    <div class="git-area">
        <LoadingContentView isLoading={isLoading}>
            <ArraySlotView array={gitStatusArray}>
                <div class="space-information-area">
                    <LabelValueView label="Git Ssh Url" value={spaceGitSshUrl}
                                    hoverTipsMessage="反映先の GitリポジトリのURLです"
                    />
                    <LabelValueView label="更新者のメールアドレス" value={mailAddress}
                                    hoverTipsMessage="更新者の名前、メールアドレスとして登録されます"
                    />
                    <LabelValueView label="更新先の Git Revision" value={diffGitRevision}
                                    hoverTipsMessage="割り込みで他の方が更新した場合、Git Revisionが変わっていることがあり、その場合、反映できません"/>
                    <LabelValueView label="更新データ作成日時" value={diffCreatedAt}/>

                </div>

                {#if spaceGitWebUrl != null}
                    <div class="git-web-url-area">
                        <a href={spaceGitWebUrl} target="_blank" rel="noopener">
                            <ButtonView fontAwesomeIcon="table" text="ブラウザで状況を見る"/>
                        </a>
                    </div>
                {/if}


                <h2>Git Status</h2>
                <TipsMessageAreaView>
                    全体の変更した概要を表示しています。
                </TipsMessageAreaView>

                <div class="git-status-area">
                    {#each gitStatusArray as gitStatus}
                        <div class="git-status-row">
                            {gitStatus}
                        </div>
                    {/each}
                </div>

                <h2>Git Diff</h2>
                <TipsMessageAreaView>
                    既に存在するファイルで変更した差分を表示しています
                </TipsMessageAreaView>
                <div class="git-diff-area">
                    {#each gitDiffArray as gitDiff}
                        <DiffRowView text={gitDiff}/>
                    {/each}

                    {#if gitDiffArray.length === 0}
                        既存ファイルの変更差分はありません
                    {/if}
                </div>

                {#if isCommittable}
                    <div class="commit-push-area ">
                        <TipsMessageAreaView>
                            コミットメッセージを入力し、 Commit & Push で Git に反映することができます
                        </TipsMessageAreaView>
                        <div>
                            <textarea class="commit-message" bind:value={commitMessage}
                                      placeholder="コミットメッセージを入力してください"/>
                        </div>
                        <div>
                            <ButtonView isPrimary={true} on:click={onClickCommitPush} disabled={commitMessage === ''}
                                        fontAwesomeIcon="code-commit"
                                        text="Commit & Push"
                            />

                        </div>

                    </div>
                {/if}


            </ArraySlotView>
        </LoadingContentView>

    </div>


</div>
<style lang="scss">
    .diff-temporary-csv-page {


        .git-area {

            .space-information-area {

            }

            .git-web-url-area {
                margin-top: 18px;
            }

            .git-status-area {
                white-space: pre;
                border-style: solid;
                border-width: 1px;
                padding: 1em;

                font-size: 0.8em;
                background-color: #fff;
                color: #222;
            }

            .git-diff-area {
                white-space: pre;
                border-style: solid;
                border-width: 1px;
                padding-top: 1em;
                padding-bottom: 1em;

                font-size: 0.8em;
                background-color: #fff;
                color: #222;


            }

            .commit-push-area {
                margin-top: 60px;

                .commit-message {
                    width: 500px;
                }

            }
        }


    }
</style>